// report to sg BI
export var TRACKING_OPERATION;
(function (TRACKING_OPERATION) {
  TRACKING_OPERATION["VIEW"] = "view";
  TRACKING_OPERATION["CLICK"] = "click";
  TRACKING_OPERATION["Scroll"] = "action_scroll";
  TRACKING_OPERATION["IMPRESSION"] = "impression";
  TRACKING_OPERATION["PERFORMANCE"] = "performance";
  TRACKING_OPERATION["ACTION_HIPO"] = "action_hipo";
  TRACKING_OPERATION["ACTION_START_TYPING"] = "action_start_typing";
  TRACKING_OPERATION["TO_LIVE_AGENT"] = "to_live_agent";
  TRACKING_OPERATION["REDIRECT"] = "redirect";
  TRACKING_OPERATION["EXIT"] = "exit";
  TRACKING_OPERATION["ACTION_FINISH_UPLOAD_SEND"] = "action_finish_upload_send";
  TRACKING_OPERATION["ACTION_FINISH_LOAD_HISTORY"] = "action_finish_loading";
  TRACKING_OPERATION["ACTION_START_LOAD_HISTORY"] = "action_load_history";
  TRACKING_OPERATION["LOST_TRANSIFY_KEYS"] = "lost_transify_keys";
  TRACKING_OPERATION["ACTION_LIVEAGENT_CONNECTED"] = "action_liveagent_connected";
  TRACKING_OPERATION["ACTION_LIVEAGENT_ENTER_QUEUE"] = "action_liveagent_enter_queue";
})(TRACKING_OPERATION || (TRACKING_OPERATION = {}));
export var TRACKING_PAGE;
(function (TRACKING_PAGE) {
  TRACKING_PAGE["MAIN_PAGE"] = "shopee_assistant";
  TRACKING_PAGE["GAME_HIPO_TRACK"] = "game_hipo_track";
})(TRACKING_PAGE || (TRACKING_PAGE = {}));
export var TRACKING_SECTION;
(function (TRACKING_SECTION) {
  TRACKING_SECTION["newHotQuestionCat"] = "hot_question";
  TRACKING_SECTION["hotQuestionCat"] = "hot_question";
  TRACKING_SECTION["hotQuestion"] = "hot_question";
  TRACKING_SECTION["shortcut"] = "bottom_question";
  TRACKING_SECTION["article"] = "";
  TRACKING_SECTION["articleGroup"] = "";
  TRACKING_SECTION["button"] = "";
  TRACKING_SECTION["order"] = "";
  TRACKING_SECTION["otherOrder"] = "";
  TRACKING_SECTION["panelOrder"] = "order_panel";
  TRACKING_SECTION["singleOrderCard"] = "";
  TRACKING_SECTION["agent"] = "";
  TRACKING_SECTION["back"] = "";
  TRACKING_SECTION["shopeePay"] = "shopee_pay";
  TRACKING_SECTION["shopeePayPanel"] = "shopee_pay_panel";
  TRACKING_SECTION["shopeePayTransactionCard"] = "shopee_pay";
  TRACKING_SECTION["shopeePayOtherTransaction"] = "shopee_pay";
  TRACKING_SECTION["shopeePayDontSeeButton"] = "shopee_pay";
  TRACKING_SECTION["shopeePayPanelTransactionCard"] = "shopee_pay_panel";
  TRACKING_SECTION["shopeePayPanelDontSeeButton"] = "shopee_pay_panel";
  TRACKING_SECTION["typingSuggestion"] = "";
  TRACKING_SECTION["standardizeButton"] = "standardize_button";
  TRACKING_SECTION["chatSessionConflict"] = "";
  TRACKING_SECTION["loadingHistory"] = "";
  TRACKING_SECTION["reloadImage"] = "";
  TRACKING_SECTION["reloadArticle"] = "";
  TRACKING_SECTION["deletedArticle"] = "";
  TRACKING_SECTION["scrollToBottom"] = "";
  TRACKING_SECTION["newMsgPopUp"] = "";
  TRACKING_SECTION["noMoreMessage"] = "";
  TRACKING_SECTION["noMoreMessageExceedDuration"] = "";
  TRACKING_SECTION["image"] = "";
  TRACKING_SECTION["file"] = "";
  TRACKING_SECTION["video"] = "";
  TRACKING_SECTION["plusPanelGallery"] = "plus_panel";
  TRACKING_SECTION["plusPanelCamera"] = "plus_panel";
  TRACKING_SECTION["plusPanelFile"] = "plus_panel";
  TRACKING_SECTION["videoPlayButton"] = "";
  TRACKING_SECTION["videoResend"] = "";
  TRACKING_SECTION["scrollDownToViewHistory"] = "";
  TRACKING_SECTION["announcement"] = "redirect";
  TRACKING_SECTION["plusPanelOrders"] = "plus_panel";
  TRACKING_SECTION["myOrderListSubTab"] = "my_order_list";
  TRACKING_SECTION["myOrderListMainTab"] = "my_order_list";
  TRACKING_SECTION["myOrderListOrderDetails"] = "my_order_list";
  TRACKING_SECTION["myOrderListSelectOrder"] = "my_order_list";
  TRACKING_SECTION["myOrderListOrder"] = "my_order_list";
  TRACKING_SECTION["resendOrder"] = "";
  TRACKING_SECTION["orderMessage"] = "";
  TRACKING_SECTION["lostTransifyKeys"] = "lost_transify_keys";
  TRACKING_SECTION["userQueueText"] = "user_queue_text";
  TRACKING_SECTION["userQueueTextImpress"] = "user_queue_text";
  TRACKING_SECTION["userCancelQueuePopUp"] = "user_cancel_queue_pop_up";
  TRACKING_SECTION["userEmailQueuePopUp"] = "user_email_us_pop_up";
  TRACKING_SECTION["articleDetail"] = "article_detail";
  TRACKING_SECTION["jumpIntent"] = "node_subtext_bubble";
  TRACKING_SECTION["keyAnswerDetail"] = "key_answer_detail";
  TRACKING_SECTION["webform"] = "webform";
  TRACKING_SECTION["richtextDetail"] = "rich_text_detail";
  TRACKING_SECTION["AccordionDetail"] = "accordion_detail";
})(TRACKING_SECTION || (TRACKING_SECTION = {}));
export var TRACKING_TARGET;
(function (TRACKING_TARGET) {
  TRACKING_TARGET["toLiveAgent"] = "to_live_agent";
  TRACKING_TARGET["newHotQuestionCat"] = "category_tab";
  TRACKING_TARGET["hotQuestionCat"] = "question_category";
  TRACKING_TARGET["hotQuestion"] = "question";
  TRACKING_TARGET["shortcut"] = "question";
  TRACKING_TARGET["article"] = "article";
  TRACKING_TARGET["articleGroup"] = "article_group";
  TRACKING_TARGET["button"] = "button";
  TRACKING_TARGET["standardizeButton"] = "button";
  TRACKING_TARGET["order"] = "order";
  TRACKING_TARGET["otherOrder"] = "other_order";
  TRACKING_TARGET["panelOrder"] = "order";
  TRACKING_TARGET["singleOrderCard"] = "single_order_card";
  TRACKING_TARGET["agent"] = "chat_with_agent";
  TRACKING_TARGET["back"] = "back_button";
  TRACKING_TARGET["shopeePayTransactionCard"] = "transaction_card";
  TRACKING_TARGET["shopeePayPanelTransactionCard"] = "transaction_card";
  TRACKING_TARGET["shopeePayDontSeeButton"] = "dont_see_button";
  TRACKING_TARGET["shopeePayPanelDontSeeButton"] = "dont_see_button";
  TRACKING_TARGET["shopeePayOtherTransaction"] = "other_transaction";
  TRACKING_TARGET["typingSuggestion"] = "suggestion";
  TRACKING_TARGET["chatSessionConflict"] = "chat_session_conflict";
  TRACKING_TARGET["loadingHistory"] = "loading_history";
  TRACKING_TARGET["reloadImage"] = "reload_image";
  TRACKING_TARGET["reloadArticle"] = "reload_article";
  TRACKING_TARGET["deletedArticle"] = "deleted_article";
  TRACKING_TARGET["scrollToBottom"] = "scroll_to_down";
  TRACKING_TARGET["newMsgPopUp"] = "new_message_pop_up";
  TRACKING_TARGET["noMoreMessage"] = "no_more_message";
  TRACKING_TARGET["noMoreMessageExceedDuration"] = "no_more_message_exceed_duration";
  TRACKING_TARGET["image"] = "image";
  TRACKING_TARGET["file"] = "file";
  TRACKING_TARGET["plusPanelGallery"] = "gallery";
  TRACKING_TARGET["plusPanelCamera"] = "camera";
  TRACKING_TARGET["plusPanelFile"] = "file";
  TRACKING_TARGET["video"] = "video";
  TRACKING_TARGET["videoPlayButton"] = "video_play_thumbnail";
  TRACKING_TARGET["videoResend"] = "resend_video";
  TRACKING_TARGET["mySupportCaseButton"] = "my_support_case_button";
  TRACKING_TARGET["scrollDownToViewHistory"] = "scroll_down_to_view_history";
  TRACKING_TARGET["announcement"] = "announcement";
  TRACKING_TARGET["plusPanelOrders"] = "orders";
  TRACKING_TARGET["myOrderListSubTab"] = "sub_tab";
  TRACKING_TARGET["myOrderListMainTab"] = "main_tab";
  TRACKING_TARGET["myOrderListOrderDetails"] = "order_details";
  TRACKING_TARGET["myOrderListSelectOrder"] = "select_order";
  TRACKING_TARGET["myOrderListOrder"] = "order";
  TRACKING_TARGET["resendOrder"] = "resend_order";
  TRACKING_TARGET["orderMessage"] = "order_message";
  TRACKING_TARGET["userQueueText"] = "button";
  TRACKING_TARGET["userCancelQueuePopUp"] = "button";
  TRACKING_TARGET["userEmailQueuePopUp"] = "button";
  TRACKING_TARGET["closeArticle"] = "close_article";
  TRACKING_TARGET["hyperlink"] = "hyperlink";
  TRACKING_TARGET["imageOrGif"] = "image_or_gif";
  TRACKING_TARGET["redirectionButton"] = "redirection_button";
  TRACKING_TARGET["accordionCardTitle"] = "accordion_card_title";
  TRACKING_TARGET["jumpIntent"] = "button";
  TRACKING_TARGET["webform"] = "webform_field";
  TRACKING_TARGET["closeWebform"] = "close_list";
  TRACKING_TARGET["webformButton"] = "button";
  TRACKING_TARGET["table"] = "table";
})(TRACKING_TARGET || (TRACKING_TARGET = {}));
export var TRACKING_TYPE;
(function (TRACKING_TYPE) {
  TRACKING_TYPE["toLiveAgent"] = "toLiveAgent";
  TRACKING_TYPE["NEW_HOT_QUESTION_CAT"] = "newHotQuestionCat";
  TRACKING_TYPE["HOTQUESTIONCAT"] = "hotQuestionCat";
  TRACKING_TYPE["HOTQUESTION"] = "hotQuestion";
  TRACKING_TYPE["SHORTCUT"] = "shortcut";
  TRACKING_TYPE["ARTICLE"] = "article";
  TRACKING_TYPE["ARTICLEGROUP"] = "articleGroup";
  TRACKING_TYPE["BUTTON"] = "button";
  TRACKING_TYPE["ORDER"] = "order";
  TRACKING_TYPE["OTHERORDER"] = "otherOrder";
  TRACKING_TYPE["SINGLE_ORDER_CARD"] = "singleOrderCard";
  TRACKING_TYPE["PANELORDER"] = "panelOrder";
  TRACKING_TYPE["AGENT"] = "agent";
  TRACKING_TYPE["BACK"] = "back";
  TRACKING_TYPE["SHOPEE_PAY_TRANSACTION_CARD"] = "shopeePayTransactionCard";
  TRACKING_TYPE["SHOPEE_PAY_PANEL_TRANSACTION_CARD"] = "shopeePayPanelTransactionCard";
  TRACKING_TYPE["SHOPEE_PAY_DONT_SEE_BUTTON"] = "shopeePayDontSeeButton";
  TRACKING_TYPE["SHOPEE_PAY_PANEL_DONT_SEE_BUTTON"] = "shopeePayPanelDontSeeButton";
  TRACKING_TYPE["SHOPEE_PAY_OTHER_TRANSACTION"] = "shopeePayOtherTransaction";
  TRACKING_TYPE["TYPING_SUGGESTION"] = "typingSuggestion";
  TRACKING_TYPE["STANDARDIZE_BUTTON"] = "standardizeButton";
  TRACKING_TYPE["CHAT_SESSION_CONFLICT"] = "chatSessionConflict";
  TRACKING_TYPE["LOADING_HISTORY"] = "loadingHistory";
  TRACKING_TYPE["RELOAD_IMAGE"] = "reloadImage";
  TRACKING_TYPE["RELOAD_ARTICLE"] = "reloadArticle";
  TRACKING_TYPE["DELETED_ARTICLE"] = "deletedArticle";
  TRACKING_TYPE["SCROLL_TO_BOTTOM"] = "scrollToBottom";
  TRACKING_TYPE["NEW_MSG_POP_UP"] = "newMsgPopUp";
  TRACKING_TYPE["NO_MORE_MESSAGE"] = "noMoreMessage";
  TRACKING_TYPE["NO_MORE_MESSAGE_EXCEED_DURATION"] = "noMoreMessageExceedDuration";
  TRACKING_TYPE["IMAGE"] = "image";
  TRACKING_TYPE["FILE"] = "file";
  TRACKING_TYPE["VIDEO"] = "video";
  TRACKING_TYPE["VIDEO_PLAY_BUTTON"] = "videoPlayButton";
  TRACKING_TYPE["VIDEO_RESEND"] = "videoResend";
  TRACKING_TYPE["MY_SUPPORT_CASE_BUTTON"] = "mySupportCaseButton";
  TRACKING_TYPE["SCROLL_DOWN_TO_VIEW_HISTORY"] = "scrollDownToViewHistory";
  TRACKING_TYPE["ANNOUNCEMENT"] = "announcement";
  TRACKING_TYPE["MY_ORDER_LIST_SUB_TAB"] = "myOrderListSubTab";
  TRACKING_TYPE["MY_ORDER_LIST_MAIN_TAB"] = "myOrderListMainTab";
  TRACKING_TYPE["MY_ORDER_LIST_ORDER_DETAILS"] = "myOrderListOrderDetails";
  TRACKING_TYPE["MY_ORDER_LIST_SELECT_ORDER"] = "myOrderListSelectOrder";
  TRACKING_TYPE["MY_ORDER_LIST_ORDER"] = "myOrderListOrder";
  TRACKING_TYPE["RESEND_ORDER"] = "resendOrder";
  TRACKING_TYPE["ORDER_MESSAGE"] = "orderMessage";
  TRACKING_TYPE["USER_QUEUE_TEXT"] = "userQueueText";
  TRACKING_TYPE["USER_QUEUE_TEXT_IMPRESS"] = "userQueueTextImpress";
  TRACKING_TYPE["USER_CANCEL_QUEUE_POPUP"] = "userCancelQueuePopUp";
  TRACKING_TYPE["USER_EMAIL_QUEUE_POPUP"] = "userEmailQueuePopUp";
  TRACKING_TYPE["ARTICLE_DETAIL"] = "articleDetail";
  TRACKING_TYPE["JUMP_INTENT"] = "jumpIntent";
  TRACKING_TYPE["WEBFORM"] = "webform";
})(TRACKING_TYPE || (TRACKING_TYPE = {}));
export var ARTICLE_DETAIL_ANSWER_TYPE;
(function (ARTICLE_DETAIL_ANSWER_TYPE) {
  ARTICLE_DETAIL_ANSWER_TYPE["RICH_TEXT"] = "rich text";
  ARTICLE_DETAIL_ANSWER_TYPE["ARTICLE"] = "article";
})(ARTICLE_DETAIL_ANSWER_TYPE || (ARTICLE_DETAIL_ANSWER_TYPE = {}));
export var ARTICLE_DETAIL_HYPERLINK_TYPE;
(function (ARTICLE_DETAIL_HYPERLINK_TYPE) {
  ARTICLE_DETAIL_HYPERLINK_TYPE["IN_APP"] = "In App";
  ARTICLE_DETAIL_HYPERLINK_TYPE["HTTPS"] = "https";
  ARTICLE_DETAIL_HYPERLINK_TYPE["HTTP"] = "http";
  ARTICLE_DETAIL_HYPERLINK_TYPE["INTENT"] = "intent";
  ARTICLE_DETAIL_HYPERLINK_TYPE["FORM_URL"] = "Form Url";
})(ARTICLE_DETAIL_HYPERLINK_TYPE || (ARTICLE_DETAIL_HYPERLINK_TYPE = {}));